// The portal forwards the PD/UO CreditLabels node inside creditSetup. A missing, empty or "NA"
// value falls back to the translation key, and a configured value is used as the key so text
// that matches a translation still switches to Spanish.
export function creditLabelKey(value: string | null | undefined, fallbackKey: string): string {
  const trimmed = value?.trim();
  return trimmed && trimmed.toUpperCase() !== 'NA' ? trimmed : fallbackKey;
}
